import { Badge } from "../Badge"
import { Icon, type IconName } from "../Icon"
import { Text } from "../Text"
import styles from "./RadioBigCard.module.css"
import { useRadioItem } from "./RadioGroup"
import { RadioItem } from "./RadioItem"

export interface RadioBigCardProps {
  icon: IconName
  title: string
  badge?: {
    icon: IconName
    title: string
  }
  description: string
  disabled?: boolean
}

export function RadioBigCard(props: RadioBigCardProps) {
  const { icon, title, badge, description, disabled = false } = props

  const { isSelected } = useRadioItem()

  return (
    <RadioItem disabled={disabled}>
      <div className={styles.radioBigCard}>
        <div className={styles.iconContainer}>
          <Icon
            name={icon}
            size="large"
            color={isSelected ? "purple9" : "grey9"}
          />
        </div>
        <div className={styles.texts}>
          <div className={styles.title}>
            <Text variant="h4" color={isSelected ? "purple12" : "grey12"}>
              {title}
            </Text>
            {badge && (
              <Badge
                size="medium"
                color="green"
                icon={badge.icon}
                title={badge.title}
              />
            )}
          </div>
          <Text variant="normal" color={isSelected ? "purple12" : "grey11"}>
            {description}
          </Text>
        </div>
      </div>
    </RadioItem>
  )
}
